import TreeNode from 'primereact/treenode'
import {Observation} from '../model/observation'

export interface Competence extends TreeNode {
	key: string,
	dbId: number,
	label: string,
	icon: string,
	children?: Competence[] | undefined
}

export const professionalCompetenceTree: Competence = {
	key: '1',
	label: 'competence_tree.1',
	icon: 'fas fa-briefcase',
	dbId: 1,
	children: [
		{
			key: '1-1-0',
			dbId: 1,
			label: 'competence_tree.1-1-0',
			icon: '',
			children: [
				{
					key: '1-1-1',
					dbId: 1,
					label: 'competence_tree.1-1-1',
					icon: ''
				}
			]
		},
		{
			key: '1-2-0',
			dbId: 2,
			label: 'competence_tree.1-2-0',
			icon: '',
			children: [
				{
					key: '1-2-1',
					dbId: 2,
					label: 'competence_tree.1-2-1',
					icon: ''
				},
				{
					key: '1-2-2',
					dbId: 3,
					label: 'competence_tree.1-2-2',
					icon: ''
				}
			]
		},
		{
			key: '1-3-0',
			dbId: 3,
			label: 'competence_tree.1-3-0',
			icon: '',
			children: [
				{
					key: '1-3-1',
					dbId: 4,
					label: 'competence_tree.1-3-1',
					icon: ''
				}
			]
		},
		{
			key: '1-4-0',
			dbId: 4,
			label: 'competence_tree.1-4-0',
			icon: '',
			children: [
				{
					key: '1-4-1',
					dbId: 5,
					label: 'competence_tree.1-4-1',
					icon: ''
				}
			]
		}
	]
}

export const methodologicalCompetenceTree: Competence = {
	key: '2',
	dbId: 2,
	label: 'competence_tree.2',
	icon: 'fab fa-searchengin',
	children: [
		{
			key: '2-1-0',
			dbId: 5,
			label: 'competence_tree.2-1-0',
			icon: '',
			children: [
				{
					key: '2-1-1',
					dbId: 6,
					label: 'competence_tree.2-1-1',
					icon: ''
				},
				{
					key: '2-1-2',
					dbId: 7,
					label: 'competence_tree.2-1-2',
					icon: ''
				},
				{
					key: '2-1-3',
					dbId: 8,
					label: 'competence_tree.2-1-3',
					icon: ''
				},
				{
					key: '2-1-4',
					dbId: 9,
					label: 'competence_tree.2-1-4',
					icon: ''
				}
			]
		},
		{
			key: '2-2-0',
			dbId: 6,
			label: 'competence_tree.2-2-0',
			icon: '',
			children: [
				{
					key: '2-2-1',
					dbId: 10,
					label: 'competence_tree.2-2-1',
					icon: ''
				},
				{
					key: '2-2-2',
					dbId: 11,
					label: 'competence_tree.2-2-2',
					icon: ''
				},
				{
					key: '2-2-3',
					dbId: 12,
					label: 'competence_tree.2-2-3',
					icon: ''
				}
			]
		},
		{
			key: '2-3-0',
			dbId: 7,
			label: 'competence_tree.2-3-0',
			icon: '',
			children: [
				{
					key: '2-3-1',
					dbId: 13,
					label: 'competence_tree.2-3-1',
					icon: ''
				},
				{
					key: '2-3-2',
					dbId: 14,
					label: 'competence_tree.2-3-2',
					icon: ''
				},
				{
					key: '2-3-3',
					dbId: 15,
					label: 'competence_tree.2-3-3',
					icon: ''
				},
				{
					key: '2-3-4',
					dbId: 16,
					label: 'competence_tree.2-3-4',
					icon: ''
				},
				{
					key: '2-3-5',
					dbId: 17,
					label: 'competence_tree.2-3-5',
					icon: ''
				}
			]
		},
		{
			key: '2-4-0',
			dbId: 8,
			label: 'competence_tree.2-4-0',
			icon: '',
			children: [
				{
					key: '2-4-1',
					dbId: 18,
					label: 'competence_tree.2-4-1',
					icon: ''
				},
				{
					key: '2-4-2',
					dbId: 19,
					label: 'competence_tree.2-4-2',
					icon: ''
				}
			]
		}
	]
}

export const socialCompetenceTree: Competence = {
	key: '3',
	dbId: 3,
	label: 'competence_tree.3',
	icon: 'fas fa-people-arrows',
	children: [
		{
			key: '3-1-0',
			dbId: 9,
			label: 'competence_tree.3-1-0',
			icon: '',
			children: [
				{
					key: '3-1-1',
					dbId: 20,
					label: 'competence_tree.3-1-1',
					icon: ''
				},
				{
					key: '3-1-2',
					dbId: 21,
					label: 'competence_tree.3-1-2',
					icon: ''
				},
				{
					key: '3-1-3',
					dbId: 22,
					label: 'competence_tree.3-1-3',
					icon: ''
				}
			]
		},
		{
			key: '3-2-0',
			dbId: 10,
			label: 'competence_tree.3-2-0',
			icon: '',
			children: [
				{
					key: '3-2-1',
					dbId: 23,
					label: 'competence_tree.3-2-1',
					icon: ''
				},
				{
					key: '3-2-2',
					dbId: 24,
					label: 'competence_tree.3-2-2',
					icon: ''
				}
			]
		},
		{
			key: '3-3-0',
			dbId: 11,
			label: 'competence_tree.3-3-0',
			icon: '',
			children: [
				{
					key: '3-3-1',
					dbId: 25,
					label: 'competence_tree.3-3-1',
					icon: ''
				},
				{
					key: '3-3-2',
					dbId: 26,
					label: 'competence_tree.3-3-2',
					icon: ''
				},
				{
					key: '3-3-3',
					dbId: 27,
					label: 'competence_tree.3-3-3',
					icon: ''
				}
			]
		},
		{
			key: '3-4-0',
			dbId: 12,
			label: 'competence_tree.3-4-0',
			icon: '',
			children: [
				{
					key: '3-4-1',
					dbId: 28,
					label: 'competence_tree.3-4-1',
					icon: ''
				},
				{
					key: '3-4-2',
					dbId: 29,
					label: 'competence_tree.3-4-2',
					icon: ''
				},
				{
					key: '3-4-3',
					dbId: 30,
					label: 'competence_tree.3-4-3',
					icon: ''
				},
				{
					key: '3-4-4',
					dbId: 31,
					label: 'competence_tree.3-4-4',
					icon: ''
				}
			]
		}
	]
}

export const selfCompetenceTree: Competence = {
	key: '4',
	dbId: 4,
	label: 'competence_tree.4',
	icon: 'fas fa-portrait',
	children: [
		{
			key: '4-1-0',
			dbId: 13,
			label: 'competence_tree.4-1-0',
			icon: '',
			children: [
				{
					key: '4-1-1',
					dbId: 32,
					label: 'competence_tree.4-1-1',
					icon: ''
				},
				{
					key: '4-1-2',
					dbId: 33,
					label: 'competence_tree.4-1-2',
					icon: ''
				},
				{
					key: '4-1-3',
					dbId: 34,
					label: 'competence_tree.4-1-3',
					icon: ''
				}
			]
		},
		{
			key: '4-2-0',
			dbId: 14,
			label: 'competence_tree.4-2-0',
			icon: '',
			children: [
				{
					key: '4-2-1',
					dbId: 35,
					label: 'competence_tree.4-2-1',
					icon: ''
				},
				{
					key: '4-2-2',
					dbId: 36,
					label: 'competence_tree.4-2-2',
					icon: ''
				},
				{
					key: '4-2-3',
					dbId: 37,
					label: 'competence_tree.4-2-3',
					icon: ''
				}
			]
		},
		{
			key: '4-3-0',
			dbId: 15,
			label: 'competence_tree.4-3-0',
			icon: '',
			children: [
				{
					key: '4-3-1',
					dbId: 38,
					label: 'competence_tree.4-3-1',
					icon: ''
				},
				{
					key: '4-3-2',
					dbId: 39,
					label: 'competence_tree.4-3-2',
					icon: ''
				},
				{
					key: '4-3-3',
					dbId: 40,
					label: 'competence_tree.4-3-3',
					icon: ''
				}
			]
		},
		{
			key: '4-4-0',
			dbId: 16,
			label: 'competence_tree.4-4-0',
			icon: '',
			children: [
				{
					key: '4-4-1',
					dbId: 41,
					label: 'competence_tree.4-4-1',
					icon: ''
				},
				{
					key: '4-4-2',
					dbId: 42,
					label: 'competence_tree.4-4-2',
					icon: ''
				},
				{
					key: '4-4-3',
					dbId: 43,
					label: 'competence_tree.4-4-3',
					icon: ''
				}
			]
		}
	]
}

export const learningDocumentationTree: Competence = {
	key: '5',
	dbId: 5,
	label: 'competence_tree.5',
	icon: 'fas fa-book',
	children: [
		{
			key: '5-1-0',
			dbId: 17,
			label: 'competence_tree.5-1-0',
			icon: ''
		},
		{
			key: '5-2-0',
			dbId: 18,
			label: 'competence_tree.5-2-0',
			icon: ''
		}
	]
}

export const performanceInSchoolAndCoursesTree: Competence = {
	key: '6',
	dbId: 6,
	label: 'competence_tree.6',
	icon: 'fas fa-graduation-cap',
	children: [
		{
			key: '6-1-0',
			dbId: 19,
			label: 'competence_tree.6-1-0',
			icon: ''
		},
		{
			key: '6-2-0',
			dbId: 20,
			label: 'competence_tree.6-2-0',
			icon: ''
		},
		{
			key: '6-3-0',
			dbId: 21,
			label: 'competence_tree.6-3-0',
			icon: ''
		}
	]
}

export const getCompetenceTree: Competence[] = [
	{
		key: '0',
		label: 'competence_tree.0',
		icon: 'fas fa-certificate',
		dbId: 0,
		children: [
			professionalCompetenceTree,
			methodologicalCompetenceTree,
			socialCompetenceTree,
			selfCompetenceTree,
			learningDocumentationTree,
			performanceInSchoolAndCoursesTree
		]
	}
]

const comps = getCompetenceTree[0].children

export const findCompetenceNodeByKey = (competenceKey: string): Competence | undefined => {
	if (!comps) {
		return undefined
	}
	for (let i = 0; i < comps.length; i++) {
		const competenceDetails = comps[i]?.children
		if (competenceDetails) {
			for (let j = 0; j < competenceDetails.length; j++) {
				if (competenceKey === competenceDetails[j].key) {
					return competenceDetails[j]
				}
			}
		}
	}
	return undefined
}

export const findCompetenceNodeByObservation = (observation: Observation): Competence | undefined => {
	let node
	if (!comps) {
		return undefined
	}
	for (let i = 0; i < comps.length; i++) {
		const subCompetences = comps[i].children
		if (!subCompetences) {
			return
		}
		for (let k = 0; k < subCompetences.length; k++) {
			const subCompetenceDbId = subCompetences[k].dbId
			// does the subCompetence match the subCompetence of the given Observation?
			if (observation.id_sub_competence === subCompetenceDbId) {

				// does the Observation have a competence detail reference?
				if (observation.id_competence_detail) {
					const competenceDetails = subCompetences[k]?.children
					if (competenceDetails) {
						for (let j = 0; j < competenceDetails.length; j++) {
							if (observation.id_competence_detail === competenceDetails[j].dbId) {
								node = competenceDetails[j]
								return node
							}
						}
					}
				} else {
					node = subCompetences[k]
					return node
				}
			}
		}
	}
	return undefined
}